// src/components/helpcenter/walkthroughs.js
// Step data for each Help Center guided walkthrough.
// Each walkthrough is an array of step objects that drive the step-card UI
// and pulse/highlight behaviour in the docking station.
//
// Text uses \n\n to separate paragraphs — HelpCenter renders them as <p> tags.

const WALKTHROUGHS = {
  'change-profile': {
    label: 'How do I change my profile?',
    steps: [
      {
        title: 'Your Profile Assistant',
        text: 'Changing your profile is easy! And we encourage you to do it often.\n\nYour profile, your company profile or a team profile (if you join a team) can be shared to all of the social platforms we support, and by email on a continuous basis.\n\nYou want your profile to change often, so adding reviews, updating your business description or changing your profile photo signals a dated change and your profile becomes shareable, if you are on a team. If no changes, it is shareable every 30 days, per platform.\n\nLook to the right — click the flashing gold button on the docking station. That\u2019s your Profile Assistant.',
        pulseTarget: 'profile',
        bringToFront: 'profileAssistant',
        autoAdvanceOn: 'profile-opened',
      },
    ],
  },

  'manage-team': {
    label: 'What does a team do for me?',
    steps: [
      {
        title: 'Coming Soon',
        text: 'Team management walkthroughs are being built. Check back soon!',
        pulseTarget: null,
        bringToFront: null,
        autoAdvanceOn: null,
      },
    ],
  },

  'create-post': {
    label: 'What is the Design Center?',
    steps: [
      {
        title: 'Your Design Center',
        text: 'The Design Center is where you create professional posts for your business.\n\nThe eHandshake AI assistant will generate custom post ideas exclusively for your profession. It gives you unique, personalized, per-social-platform captions, creates a landing page for your post (or use your own) where you can choose from multiple layouts and colors, and produce AI assisted company or industry specific content — all in one place. In less than 5 minutes!!\n\n You will have access to 3.2 Million stock images and videos\n\nLook to the right — click the flashing gold button on the docking station. That\u2019s your Design Center.',
        pulseTarget: 'designCenter',
        bringToFront: 'designCenter',
        autoAdvanceOn: 'designCenter-opened',
      },
    ],
  },

  'share-social': {
    label: 'What is the Sharing Center?',
    steps: [
      {
        title: 'Your Sharing Center',
        text: 'The Sharing Center is your social posting and email hub. \n\nCreations from the Design Center appear here. Post your own creations, profile, company profile or team profile to any social media platform we support. Post any creations or profiles of a teammate, if you decide to join a team. A team can amplify your message by getting it into their channels. More eyes. More exposure.\n\nWe currently support — Facebook, Instagram, X, LinkedIn, TikTok and by email. But we will be adding other channels soon.\n\nLook to the right — click the flashing gold button on the docking station. That\u2019s your Sharing Center.',
        pulseTarget: 'sharingCenter',
        bringToFront: 'sharingCenter',
        autoAdvanceOn: 'sharingCenter-opened',
      },
    ],
  },

  'send-message': {
    label: 'How do I invite someone to chat?',
    steps: [
      {
        title: 'Your Message Center',
        text: 'The Message Center is where all your conversations live.\n\nYou can chat with teammates, clients, or anyone in the eHandshake network. Start a new conversation or continue an existing one.\n\nMessages are delivered in real time, so you\u2019ll never miss an important conversation.\n\nLook to the right — click the flashing gold button on the docking station. That\u2019s your Message Center.',
        pulseTarget: 'chat',
        bringToFront: 'chat',
        autoAdvanceOn: 'chat-opened',
      },
    ],
  },

  'update-subscription': {
    label: 'How do I update my subscription?',
    steps: [
      {
        title: 'Coming Soon',
        text: 'Subscription management walkthroughs are being built. Check back soon!',
        pulseTarget: null,
        bringToFront: null,
        autoAdvanceOn: null,
      },
    ],
  },

  'change-notifications': {
    label: 'How do I change my notifications?',
    steps: [
      {
        title: 'Coming Soon',
        text: 'Notification setting walkthroughs are being built. Check back soon!',
        pulseTarget: null,
        bringToFront: null,
        autoAdvanceOn: null,
      },
    ],
  },

  'update-privacy': {
    label: 'How do I update my privacy settings?',
    steps: [
      {
        title: 'Coming Soon',
        text: 'Privacy setting walkthroughs are being built. Check back soon!',
        pulseTarget: null,
        bringToFront: null,
        autoAdvanceOn: null,
      },
    ],
  },
};

export default WALKTHROUGHS;
